import { useState } from "react";
import { useContentGeneration } from "../hooks/useContentGeneration";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useSubscription } from "../hooks/useSubscription";

function DynamicFormGenerator() {
    var CustomTag = "";
    const[error,setError] = useState();
const[value,setValue] = useState();
const[template,setTemplate] = useState();
const{subsInfo} = useSubscription()
const [set,setIsDisabled] = useState(false)
const notify = (response) => toast(response);
    const {sendDynamicFlashTemRequest, saveDynamicTemplate} = useContentGeneration();

    const handleForm = async(e) =>{
        e.preventDefault()
        const data= {keyword:value}
        setIsDisabled(true)
         const res = await sendDynamicFlashTemRequest(data)
         if(res && res.template){

       
         const templateObject = await JSON.parse(res.template)
         setTemplate(templateObject)
        }else{
            setError("Session has expired, refresh the page to continue")
        }
        setIsDisabled(false)
    
    }

    const saveDynamicFlash = async(e) =>{
        e.preventDefault()
        const data = {flash:template}
        const save = await saveDynamicTemplate(data)
        console.log(save)
        notify(save)
    }

    return(


        <div className="min-h-screen lg:w-3/4 md:w-3/4 sm:w-3/4 w-2/3  mx-auto">
     

        
<div className="grid border p-3 rounded mt-5 font-Rajdhani">

<form onSubmit={handleForm}>
    <label for="keyword" className="text-3xl">Generate your own content generator flash 🪄</label><br/>
    <textarea type="text" className="mt-3 w-3/4 rounded p-1 border shadow-sm dark:bg-[#2c2f44] dark:text-[#99a0ac]" name="keyword" placeholder="What do you want create?" required onChange={(e)=>setValue(e.target.value)}/>
  
    { subsInfo && 

subsInfo.status === "inactive" 

?subsInfo.details.words >=subsInfo.details.totalwords    ?

<button className="ml-4  pt-1 pb-1 pl-3 pr-3 rounded dark:bg-[#818998] border shadow-sm" disabled >{set ? "Creating...." : "Create 🪄"}</button>


:   <button className="ml-4  pt-1 pb-1 pl-3 pr-3 rounded dark:bg-[#818998] border shadow-sm" disabled={set ? true : false} >{set ? "Creating...." : "Create 🪄"}</button>
: null }

</form>
{ subsInfo && 

subsInfo.status === "inactive" 

?subsInfo.details.words >=subsInfo.details.totalwords    ?
<div>
<p className="font-Rajdhani text-red-600 dark:text-red-400">Upgrade to premium or wait for a month to continue using flash.</p>


          </div>

: null : null }
</div>    
{template ? 
<div className="shadow mt-10 p-4 rounded border">
<div className="flex justify-end font-Rajdhani font-bold">
<button className="btn dark:bg-[#818998] dark:text-white dark:bg-none dark:rounded-2xl font-bold  dark:hover:bg-[#818998] dark:hover:text-white text-white font-Rajdhani  bg-gradient-to-r from-orange-700 to-orange-600" onClick={saveDynamicFlash} >Save Template</button>
</div>
<h1 className="text-left font-Rajdhani text-3xl">{template && template.FormName ?  template.FormName : null}</h1>
<p className=" font-Rajdhani text-xl font-medium">{template && template.FormTagline ? template.FormTagline : null}</p>
    <form>


    {template && template.fields.map((f)=>{
 CustomTag = f.type 
return(
    <div className="">
         <label className="font-Rajdhani text-md mt-3">{f.label}</label><br/>
         <CustomTag className=" dark:bg-[#2c2f44] dark:text-[#99a0ac] border font-normals rounded shadow-sm w-full font-Rajdhani px-3 text-gray-900 outline-none px-3 py-1 focus:outline-none"  name={f.name} placeholder={f.placeholder} required={f.isRequired} />
         </div>
)

    })}
    <p className="font-Rajdhani text-red-600 dark:text-red-400">Save the template to use it!</p>
    <button className=" btn dark:bg-[#818998] dark:text-white dark:bg-none dark:rounded-2xl  dark:hover:bg-[#818998] dark:hover:text-white text-white  bg-gradient-to-r from-orange-700 to-orange-600 mt-2" type="submit" disabled>Submit</button>
     
        </form>
    </div>
    :null}
{error ? <p className="font-Rajdhani text-xl font-bold">error</p> : null}

<ToastContainer
                    position="top-right"
                    autoClose={2000}
                    hideProgressBar={false}
                    newestOnTop={false}
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                    theme="light"
                  />
        </div>
    )
}

export default DynamicFormGenerator